import { AuthContext } from '@providers/AuthProvider'
import CloudStoreLogo from '@svgs/logo.svg'
import React, { useState } from 'react'
import Badge from 'react-bootstrap/esm/Badge'
import Navbar from 'react-bootstrap/esm/Navbar'
import UserMenu from '@components/UserMenu/UserMenu'
import HeaderLanguage from '@components/Header/HeaderLanguage'
import HeaderLogs from './HeaderLogs'
import HeaderSearchBar from './HeaderSearchBar'
import { useMobileMediaQuery } from '@utils/MediaComponents'

const Header = ()=> {
    const auth = React.useContext(AuthContext)
    const [isSearchOpen, setIsSearchOpen] = useState(false)
    const isMobile = useMobileMediaQuery()

    if(isMobile) {
        return <div className="fixed-top cs-sidebar p-2 d-flex"  style={{zIndex:9999, backgroundColor: "#F9F9F9"}}>
            <HeaderSearchBar onSearchToggle={(isOpen)=>setIsSearchOpen(isOpen)} />
            {!isSearchOpen && <div className="ms-4"><UserMenu /></div>}
        </div>
    }

    return (
        <div className="fixed-top cs-sidebar">
            <div className='d-flex align-items-center'>
                <div className="d-none d-md-block p-2" style={{width: '280px', minWidth: '280px'}}>
                    <Navbar.Brand href="/"><img src={CloudStoreLogo} width="200" alt="logo" style={{marginLeft: '1.4rem'}} /></Navbar.Brand>
                </div>
                <div className="w-100 ps-1">
                    <Navbar bg="light" expand="lg" style={{zIndex:9999}}>
                        <div className="d-flex w-100 justify-content-between align-items-center">
                            <div className="d-flex justify-content-start align-items-center w-100" style={{marginLeft: '-5px'}}>
                                <div className='d-block d-md-none'></div>
                                <div className='w-100 me-4'><HeaderSearchBar /></div>
                                {auth.environment && <Badge className="d-none d-md-block mx-4" bg="primary">{auth.environment}</Badge>}
                            </div>
                            <div className="d-flex justifiy-content-end align-items-center">
                                <div className="d-flex align-items-center"><HeaderLogs/></div>
                                <div className="ms-4"><HeaderLanguage /></div>
                                <div className="ms-4"><UserMenu /></div>
                            </div>
                        </div>
                    </Navbar>
                </div>
            </div>
        </div>
    )
}

export default Header